import React, { useState } from 'react';
import Modal from '@iso/ui/Antd/Modal/Modal';
import {
  AboutMainModalWrapper,
  AboutMainModalContentWrapper,
} from './AboutMainModal.styles';
import { Button } from '../../../cbuielements/styles/button.style';
import burgerIcon from '@iso/assets/images/aboutBurgerIcon.png';
import PizzaBurger from '@iso/assets/images/pizzaBurger.png';

import facebook from '@iso/assets/images/socials/facebook.png';
import tikTok from '@iso/assets/images/socials/tiktok.png';
import instagram from '@iso/assets/images/socials/instagram.png';
import youtube from '@iso/assets/images/socials/youtube.png';
import messenger from '@iso/assets/images/socials/messenger.png';
import whatsUp from '@iso/assets/images/socials/whatsup.png';
import telegram from '@iso/assets/images/socials/telegram.png';

import footerLogo from '@iso/assets/images/localeats/footer-logo/footerLogo.svg';
import whatsupsvgLogo from '@iso/assets/images/socials/whatsupsvg.svg';

const AboutMainModal = ({ data, marketplace }) => {
  const [aboutModalVisible, setAboutModalVisible] = useState(false);
  const [hotelModalVisible, setHotelModalVisible] = useState(false);
  const [localbytesModalVisible, setLocalbytesModalVisible] = useState(false);

  const socialsData = [
    { name: 'facebook', path: 'https://www.facebook.com/', img: facebook },
    { name: 'tikTok', path: 'https://www.tikTok.com/', img: tikTok },
    { name: 'instagram', path: 'https://www.instagram.com/', img: instagram },
    { name: 'youtube', path: 'https://www.youtube.com/', img: youtube },
    { name: 'messenger', path: 'https://www.facebook.com/', img: messenger },
    // {name: 'telegram', path: 'https://www.telegram.com/', img: telegram},
    // {name: "whats'up", path: 'https://www.whatsapp.com/', img: whatsUp},
  ];

  const socialsDataPizza = [
    { name: 'facebook', path: 'https://www.facebook.com/', img: facebook },
    { name: 'instagram', path: 'https://www.instagram.com/', img: instagram },
  ];

  let burgerImgUrl = marketplace === 'pizzabox' ? PizzaBurger : burgerIcon;

  const openAboutModal = () => {
    setHotelModalVisible(true);
  };
  const openHotelModal = () => {
    setAboutModalVisible(false);
    setHotelModalVisible(true);
  };
  const openLocalbytesModal = () => {
    setAboutModalVisible(false);
    setLocalbytesModalVisible(true);
  };

  return (
    <>
      <AboutMainModalWrapper>
        {marketplace === 'pizzabox' ? null : (
          <img
            className="about-burger-wrapper"
            src={burgerImgUrl}
            alt=""
            onClick={openAboutModal}
          />
        )}

        <Modal
          visible={aboutModalVisible}
          footer={null}
          onCancel={() => setAboutModalVisible(false)}
          centered
        >
          <AboutMainModalContentWrapper>
            <p className="about-links" onClick={openHotelModal}>
              About Sunrise Hotel
            </p>
            <p className="about-links" onClick={openLocalbytesModal}>
              About Localbytes
            </p>
            <p className="about-links" style={{ borderBottom: 'none' }}>
              Contact Us
              <div className="socials-block">
                {socialsData.map(({ name, path, img }) => (
                  <a key={name} href={path} target="_blank">
                    <img src={img} alt={name} />
                  </a>
                ))}
              </div>
            </p>
          </AboutMainModalContentWrapper>
        </Modal>

        <Modal
          visible={hotelModalVisible}
          footer={null}
          onCancel={() => setHotelModalVisible(false)}
          centered
        >
          <AboutMainModalContentWrapper>
            <h4>{data?.name}</h4>
            <p className="about-paragraph">{data?.info}</p>
            {marketplace === 'lacanada' || marketplace === 'pizzabox' ? null : (
              <p className="about-paragraph">
                <a href={`tel:+${data?.phone}`}>+{data?.phone}</a>
              </p>
            )}
            {data?.site !== '' ? (
              <p className="about-paragraph">
                <a href={data?.site} target="_blank">
                  {data?.site}
                </a>
              </p>
            ) : null}
            {/*<p className="contact-with-hotel">Contact with hotel</p>*/}
            {marketplace === 'lacanada' ? null : marketplace === 'pizzabox' ? (
              <div className="social-icons">
                {socialsDataPizza.map(({ name, path, img }) => (
                  <a key={name} target="_blank" id={path}>
                    <img src={img} alt={name} />
                  </a>
                ))}
              </div>
            ) : (
              <div className="social-icons">
                {socialsData.map(({ name, path, img }) => (
                  <a key={name} target="_blank" id={path}>
                    <img src={img} alt={name} />
                  </a>
                ))}
              </div>
            )}

            {/*<Button className="whats-Up-icon">*/}
            {/*  <a href="https://api.whatsapp.com/send?phone=14154312211">*/}
            {/*    <img src={whatsupsvgLogo} alt="" />*/}
            {/*  </a>*/}
            {/*</Button>*/}
            {marketplace === 'lacanada' ? (
              <Button>
                <a href="https://lacanadarestaurants.com/" target="_blank">
                  Partner with Us
                </a>
              </Button>
            ) : marketplace === 'pizzabox' ? null : (
              <Button>
                <a href={`tel:+${data?.phone}`}>CALL</a>
              </Button>
            )}
          </AboutMainModalContentWrapper>
        </Modal>

        <Modal
          visible={localbytesModalVisible}
          footer={null}
          onCancel={() => setLocalbytesModalVisible(false)}
          centered
        >
          <AboutMainModalContentWrapper>
            <img className="logo" src={footerLogo} alt="logo" />
            <p className="about-paragraph">New York, NY</p>
            <p className="about-paragraph">
              <a href="tel:+900300400">+1 415-431-2211</a>
            </p>
            <p className="about-paragraph">
              <a href="https://www.localbytes.co/" target="_blank">
                www.localbytes.co
              </a>
            </p>
            <Button>
              <a href="tel:+1 415-431-2211">CALL US</a>
            </Button>
          </AboutMainModalContentWrapper>
        </Modal>
      </AboutMainModalWrapper>
    </>
  );
};

export default AboutMainModal;
